import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type ProfileSegmentEventPayload = {
  idp?: number;
  status?: number;
  segment_index?: number;
  modification_type?: number;
  start_time?: number;
  basal_rate?: number;
  isf?: number;
  target_bg?: number;
  carb_ratio?: number;
};

export type ProfileSegmentEventEvent = {
  idp?: number;
  status?: number;
  segmentIndex?: number;
  modificationType?: number;
  startTime?: number;
  basalRate?: number;
  isf?: number;
  targetBg?: number;
  carbRatio?: number;
};

const profileSegmentEventSchema = z.object({
  idp: cz.permissive(z.number()),
  status: cz.permissive(z.number()),
  segment_index: cz.permissive(z.number()),
  modification_type: cz.permissive(z.number()),
  start_time: cz.permissive(z.number()),
  basal_rate: cz.permissive(z.number()),
  isf: cz.permissive(z.number()),
  target_bg: cz.permissive(z.number()),
  carb_ratio: cz.permissive(z.number()),
});

export const LID_IDP_TD_SEG = {
  value: 0x44,
  name: "Personal Profile Time Dependent Segment Event",
  format: "bbbbhhhhi1",
  fields: [
    "idp",
    "status",
    "segment_index",
    "modification_type",
    "start_time",
    "basal_rate",
    "isf",
    "target_bg",
    "carb_ratio",
  ],
  postprocess: rec => ({
    idp: rec.idp,
    status: rec.status,
    segmentIndex: rec.segment_index,
    modificationType: rec.modification_type,
    startTime: rec.start_time ? rec.start_time * 60 * 1000 : undefined,
    basalRate: rec.basal_rate ? rec.basal_rate * 0.001 : undefined,
    isf: rec.isf,
    targetBg: rec.target_bg,
    carbRatio: rec.carb_ratio ? rec.carb_ratio * 0.001 : undefined,
  }),
  schema: profileSegmentEventSchema,
} as const satisfies TandemEventDefinition<ProfileSegmentEventPayload, ProfileSegmentEventEvent>;
